import {usePaldockTranslation} from "hooks/usePaldockTranslation.tsx";

export const CascadeFailed = () => {
    const { t } = usePaldockTranslation("ui.cascade");
    return (
        <>
            <h1 className="text-2xl font-bold text-gray-800 mt-2 text-bold">{t("content.thank_you_request_contact")}</h1>
        </>
    );
};
